var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBackwards = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8.5 17-6-6 6-6 1.425 1.4-4.6 4.6 4.6 4.6L8.5 17Zm12 2v-4c0-.833-.292-1.542-.875-2.125A2.893 2.893 0 0 0 17.5 12h-6.175l3.6 3.6L13.5 17l-6-6 6-6 1.425 1.4-3.6 3.6H17.5c1.383 0 2.563.488 3.538 1.463.974.975 1.462 2.154 1.462 3.537v4h-2Z",
  fill: "currentColor"
})));

export default SvgBackwards;